import colors from '../colors';
import { buildGet } from '../../utils/typography/get';
import { buildTypes } from '../../utils/typography/types';
export const family = {
  opensans: '"Open Sans", sans-serif, Tahoma, Arial',
  roboto: 'Roboto, San Francisco, Helvetica Neue, Helvetica, Arial, sans-serif'
};
export const weight = {
  extraBold: '800',
  bold: '700',
  semiBold: '600',
  medium: '500',
  light: '400',
  regular: '400'
};
export const lineHeights = {
  base: 1.5,
  large: 1.5,
  small: 1.2,
  headings: 1,
  badge: 1,
  button: '2em',
  computed: "".concat(Math.floor(1.5 * 14), "px")
};
export const lineHeightDefaults = {
  '3XL': "line-height: ".concat(lineHeights.headings, ";"),
  '2XL': "line-height: ".concat(lineHeights.headings, ";"),
  XL: "line-height: ".concat(lineHeights.headings, ";"),
  large: "line-height: ".concat(lineHeights.headings, ";"),
  MExtra: "line-height: ".concat(lineHeights.headings, ";"),
  MSemi: "line-height: ".concat(lineHeights.headings, ";"),
  SExtra: "line-height: ".concat(lineHeights.headings, ";"),
  SSemi: "line-height: ".concat(lineHeights.headings, ";"),
  XSExtra: "line-height: ".concat(lineHeights.headings, ";"),
  XSSemi: "line-height: ".concat(lineHeights.headings, ";"),
  bodyXL: "line-height: ".concat(lineHeights.base, ";"),
  bodyL: "line-height: ".concat(lineHeights.base, ";"),
  body: "line-height: ".concat(lineHeights.base, ";"),
  bodyWide: "line-height: ".concat(lineHeights.base, ";"),
  bodyTight: "line-height: ".concat(lineHeights.base, ";"),
  bodySmall: "line-height: ".concat(lineHeights.base, ";"),
  body12: "line-height: ".concat(lineHeights.base, ";"),
  SpecialXSExtra: "line-height: ".concat(lineHeights.base, ";"),
  SpecialXSSemi: "line-height: ".concat(lineHeights.base, ";")
};
export const fontColorDefaults = {
  '3XL': "color: ".concat(colors.neutral.black, ";"),
  '2XL': "color: ".concat(colors.neutral.black, ";"),
  XL: "color: ".concat(colors.neutral.black, ";"),
  large: "color: ".concat(colors.neutral.black, ";"),
  MExtra: "color: ".concat(colors.neutral.black, ";"),
  MSemi: "color: ".concat(colors.neutral.black, ";"),
  SExtra: "color: ".concat(colors.neutral.black, ";"),
  SSemi: "color: ".concat(colors.neutral.black, ";"),
  XSExtra: "color: ".concat(colors.neutral.black, ";"),
  XSSemi: "color: ".concat(colors.neutral.black, ";"),
  bodyXL: "color: ".concat(colors.neutral.black, ";"),
  bodyL: "color: ".concat(colors.neutral.black, ";"),
  body: "color: ".concat(colors.neutral.black, ";"),
  bodyWide: "color: ".concat(colors.neutral.black, ";"),
  bodyTight: "color: ".concat(colors.neutral.black, ";"),
  body12: "color: ".concat(colors.neutral.black, ";"),
  bodySmall: "color: ".concat(colors.neutral.black, ";"),
  SpecialXSExtra: "color: ".concat(colors.neutral.black, ";"),
  SpecialXSSemi: "color: ".concat(colors.neutral.black, ";")
};
export const defaults = {
  '3XL': "\n    font-family: ".concat(family.roboto, ";\n    font-size: 32px;\n    font-weight: ").concat(weight.bold, ";\n    letter-spacing: 0;\n    text-transform: capitalize;\n  "),
  '2XL': "\n    font-family: ".concat(family.roboto, ";\n    font-size: 32px;\n    font-weight: ").concat(weight.regular, ";\n    letter-spacing: 0;\n    text-transform: capitalize;\n  "),
  XL: "\n    font-family: ".concat(family.roboto, ";\n    font-size: 24px;\n    font-weight: ").concat(weight.bold, ";\n    letter-spacing: 0;\n  "),
  large: "\n    font-family: ".concat(family.roboto, ";\n    font-size: 24px;\n    font-weight: ").concat(weight.regular, ";\n    letter-spacing: 0;\n    text-transform: capitalize;\n  "),
  MExtra: "\n    font-family: ".concat(family.roboto, ";\n    font-size: 18px;\n    font-weight: ").concat(weight.bold, ";\n    letter-spacing: 0;\n    text-transform: capitalize;\n  "),
  MSemi: "\n    font-family: ".concat(family.roboto, ";\n    font-size: 18px;\n    font-weight: ").concat(weight.regular, ";\n    letter-spacing: 0;\n    text-transform: capitalize;\n  "),
  SExtra: "\n    font-family: ".concat(family.roboto, ";\n    font-size: 16px;\n    font-weight: ").concat(weight.bold, ";\n    letter-spacing: 0;\n    text-transform: capitalize;\n  "),
  SSemi: "\n    font-family: ".concat(family.roboto, ";\n    font-size: 16px;\n    font-weight: ").concat(weight.regular, ";\n    letter-spacing: 0;\n    text-transform: capitalize;\n  "),
  XSExtra: "\n    font-family: ".concat(family.roboto, ";\n    font-size: 14px;\n    font-weight: ").concat(weight.bold, ";\n    letter-spacing: 0.5px;\n  "),
  XSSemi: "\n    font-family: ".concat(family.roboto, ";\n    font-size: 14px;\n    font-weight: ").concat(weight.bold, ";\n    letter-spacing: 0.5px;\n  "),
  bodyXL: "\n    font-family: ".concat(family.roboto, ";\n    font-size: 16px;\n    font-weight: ").concat(weight.regular, ";\n    letter-spacing: 0;\n  "),
  bodyL: "\n    font-family: ".concat(family.roboto, ";\n    font-size: 14px;\n    font-weight: ").concat(weight.bold, ";\n    letter-spacing: 0;\n  "),
  body: "\n    font-family: ".concat(family.roboto, ";\n    font-size: 14px;\n    font-weight: ").concat(weight.regular, ";\n    letter-spacing: 0;\n  "),
  bodyWide: "\n    font-family: ".concat(family.roboto, ";\n    font-size: 12px;\n    font-weight: ").concat(weight.bold, ";\n    letter-spacing: 0;\n  "),
  bodyTight: "\n    font-family: ".concat(family.roboto, ";\n    font-size: 12px;\n    font-weight: ").concat(weight.regular, ";\n    letter-spacing: 0;\n  "),
  body12: "\n    font-family: ".concat(family.roboto, ";\n    font-size: 12px;\n    font-weight: ").concat(weight.bold, ";\n    letter-spacing: 0;\n  "),
  bodySmall: "\n    font-family: ".concat(family.roboto, ";\n    font-size: 12px;\n    font-weight: ").concat(weight.regular, ";\n    letter-spacing: 0;\n  "),
  SpecialXSExtra: "\n    font-family: ".concat(family.roboto, ";\n    font-size: 10px;\n    font-weight: ").concat(weight.regular, ";\n    letter-spacing: 0;\n  "),
  SpecialXSSemi: "\n    font-family: ".concat(family.roboto, ";\n    font-size: 10px;\n    font-weight: ").concat(weight.regular, ";\n    letter-spacing: 0;\n  ")
};
export const types = buildTypes({
  defaults,
  fontColorDefaults,
  lineHeightDefaults
});
export const get = buildGet({
  defaults,
  fontColorDefaults,
  lineHeightDefaults
});
//# sourceMappingURL=typography.js.map